import { gql } from "@apollo/client";

/**
 * Subscription for real-time player stats updates.
 * Replaces polling in ProfilePage and PlayerProfilePage.
 */
export const PLAYER_STATS_SUBSCRIPTION = gql`
    subscription PlayerStatsSubscription {
        playerStats {
            bits
            checkins
            clanRank
            giftedSubs
            lifetimeVp
            overallRank
            lifetimeRank
            raids
            seasonVp
            sentryTime
            shieldValue
            shieldTwoValue
            wheelOfHamingjaWins
            exalted
            reforgeTokens
            wohTokens
            totalDonated
            merchandise
            shieldMatesCount
            ravenguardPoints
            shieldTwoVp
            shieldTwoCheckins
            shieldTwoRaids
            shieldTwoSentryTime
            shieldTwoBits
            shieldTwoGiftedSubs
            shieldTwoWheelOfHamingjaWins
            shieldTwoRavenguardPoints
            shieldTwoTotalDonated
            shieldTwoMerchandise
            shieldTwoMonthsSubscribed
            shieldTwoGotaMonths
        }
    }
`;
